import { render, staticRenderFns } from "./OccupancyDashboard.vue?vue&type=template&id=1f2d88de&scoped=true"
import script from "./OccupancyDashboard.vue?vue&type=script&lang=ts"
export * from "./OccupancyDashboard.vue?vue&type=script&lang=ts"
import style0 from "./OccupancyDashboard.vue?vue&type=style&index=0&id=1f2d88de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2d88de",
  null
  
)

export default component.exports